<template>
  <div class="current-balance">
    <p>Saldo Atual</p>
    <span :style="{ color: minimumAchieved ? '#BF0000' : '#52CC9C' }">{{ currentBalance }}</span>
  </div>
</template>

<script>
import payments from '../../api/payments'
import { formatCurrency } from '../../utils/format-currency'

export default {
  name: 'CurrentBalance',
  data: () => ({
    currentBalance: 'R$ 0,00',
    minimumAchieved: false
  }),
  mounted() {
    this.fetchCurrentBalance()
  },
  methods: {
    fetchCurrentBalance() {
      payments
        .getBalance('PREPAID')
        .then(response => {
          const { value, minimumAchieved } = response.data

          this.currentBalance = formatCurrency(value)
          this.minimumAchieved = minimumAchieved
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss">
  .current-balance {
    padding-right: 24px;

    p {
      font-size: 10px;
      color: #818181;
      margin: 0;
      width: 100%;
    }

    span {
      font-size: 16px;
      font-weight: 700;
      color: #47ba8d;
    }
  }
</style>
